import { BrandingData } from "@/hooks/types";
import { createContext } from "react";

export const BrandingContext = createContext<BrandingData | null>(null);
